import {
  readFileAsDataUrl,
  dataUrlToFile,
} from '../components/chat/utils/photoFileHelpers'

const usePhotoInput = ({
  dispatch,
  setPhotoPreview,
  setPhotoFile,
  setShowCamera,
}) => {
  const onFileChange = async (event) => {
    const input = event.target
    const file = input?.files?.[0]

    if (!file) return

    setPhotoFile(file)

    try {
      const dataUrl = await readFileAsDataUrl(file)

      dispatch(setPhotoPreview(dataUrl))
    } catch (error) {
      console.error('Unable to read selected image:', error)
      setPhotoFile(null)
      dispatch(setPhotoPreview(null))
    } finally {
      if (input) {
        input.value = ''
      }
    }
  }

  const handleCapture = (dataUrl) => {
    dispatch(setPhotoPreview(dataUrl))

    const capturedFile = dataUrlToFile(dataUrl)

    setPhotoFile(capturedFile)
    setShowCamera(false)
  }

  return {
    onFileChange,
    handleCapture,
  }
}

export default usePhotoInput